<template>
    <footer class="footer">
        <div  class="footer__copyright">
            <span>{{ $t('common.copyright') }} <span class="res-footer">{{ $t('common.realiser') }} </span> <span><a href="https://www.elyosdigital.com/" target="_blank">{{ $t('common.societe') }}</a></span></span>
        </div>
       
    </footer>
</template>




<script>
export default {
    name:"FooterElement"
}
</script>
